<template>
<div class="col-8 offset-2">

    <!-- <div class="text-center">
        <img :src="path_code" height="150px">
    </div>
    <br> -->
    <div id="accordion">
            <div class="card">
                <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                    <button class="btn btn-success btn-block" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" @click="callRole">
                        <font-awesome-icon icon="book" size="3x" /> <br>Panel principal 
                    </button>
                </h5>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <!-- <div class="alert alert-secondary" v-for="l in links" :key="l.id">
                                <router-link class="alert-link" to="/dashboard/approved-enrollment">Aprobacion Matriculas</router-link>
                        </div>  -->
                        <div class="card-body">
                            <div class="alert alert-secondary ">
                                <h5>Binvenido al Sistema</h5>
                            </div>                    
                        </div>                  
                    </div>
                </div>
            </div>            
    </div>        
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
    name:'menu-central',
    data(){
        return{
            oper:false,
            guest:false,
            admin:false,
            supadmin:false,
            finance:false,
            security:false,
            enrollment:false,
            path_code:null,
            uumm:false,
            links:[]
        }        
    },
    mounted(){        
        // this.callRole()
        this.mCallInit();
    },
    computed:{
        cUserSession(){
            return this.$store.getters.getUserState.roleAssign;
        },
        c_oper(){
            return this.oper;
        },
        c_guest(){
            return this.guest;
        },
        c_admin(){
            return this.admin;
        },
        c_supadmin(){
            return this.supadmin;
        },
        c_security(){
            return this.security;
        },
        c_finance(){
            return this.finance;
        },
        c_enrollment(){
            return this.enrollment;
        },
        c_uumm(){
            return this.uumm;
        }
    },
    methods:{
        async mCallInit(){
            this.links=[];
            let photo = await axios.get(`getPhotoGroup?api_token=${Vue.auth.getToken()}`);
            let link_aux = await axios.get(`getLinks?api_token=${Vue.auth.getToken()}`);
            // console.log(photo);
            link_aux.data.forEach(el => {
                let aux={link:el.link, title:el.title}
                this.links.push(aux);
            });
            let ext_aux=photo.data.extention;
            let ext;
            switch (ext) {
                case "jpg":
                ext = "jpeg";
                break;

                case "png":
                ext = "png";
                break;
            }

            this.path_code= `data:image/${ext};base64,${photo.data.path}`;
        },
        callRole(){
            switch(this.cUserSession){
                case 'SUPER ADMINISTRADOR':
                    this.supadmin=true;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'OPERADOR':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=true;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'SEGURIDAD':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=true;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'FINANCIERO':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=true;
                    this.guest=false;
                break;

                case 'MATRICULACION':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=true;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'MARINA MERCANTE':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.uumm=true;
                    this.guest=false;
                break;

                default:
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.uumm=false;
                    this.guest=true;
                break;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/MenuCentral.vue